import React, { createContext, useContext } from 'react';

/**
 * A report page drawn INSIDE an explorer.
 *
 * The explorers (components/reports/explorer) are new frames around blocks
 * that already exist: a tab of Marketing is today's Campaigns page, a tab of
 * Customers is today's Who Bought. Inside a frame the page must not draw its
 * own title, or every tab opens with a second heading under the explorer's.
 * PageHeader and PageContent read this and step aside; the page itself is
 * untouched, so the current reports stay exactly what they are.
 */
const Ctx = createContext(false);

export const useEmbedded = () => useContext(Ctx);

export function Embedded({ children }) {
  return <Ctx.Provider value>{children}</Ctx.Provider>;
}
